import type { DirectMessage, Conversation, PaginatedResponse } from '@olimhub/shared'
import { apiClient } from '../client'

export const messagesApi = {
  getConversations: (cursor?: string) =>
    apiClient
      .get<PaginatedResponse<Conversation>>('/messages', { params: { cursor } })
      .then((r) => r.data),

  getThread: (username: string, cursor?: string) =>
    apiClient
      .get<PaginatedResponse<DirectMessage>>(`/messages/${username}`, { params: { cursor } })
      .then((r) => r.data),

  send: (username: string, content: string) =>
    apiClient
      .post<DirectMessage>(`/messages/${username}`, { content })
      .then((r) => r.data),

  getUnreadCount: () =>
    apiClient
      .get<{ count: number }>('/messages/unread-count')
      .then((r) => r.data.count),

  deleteMessage: (messageId: string) =>
    apiClient.delete(`/messages/message/${messageId}`).then(() => undefined),
}
